import { ColDef, themeAlpine } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useMemo } from "react";

import { IgTableWrapper } from "@intelligems/ig-theme";
import {
  AgencySubscriptionDto,
  AgencySubscriptionItemDto,
  FullAgencyDto,
  OrgIdNameDto,
} from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { GrantAccessColumn } from "@src/features/admin/pages/agencies/components/Tables/UnassignedOrgsTable/renderers/GrantAccessColumn";
import { theme } from "@src/theme";

interface UnassignedOrgsTable {
  item: AgencySubscriptionItemDto;
  subscription: AgencySubscriptionDto;
  agency: FullAgencyDto;
  unassignedOrgs: OrgIdNameDto[];
}

const myTheme = themeAlpine.withParams({
  fontFamily: theme.typography.fontFamily,
});

export const UnassignedOrgsTable = ({
  item,
  subscription,
  agency,
  unassignedOrgs,
}: UnassignedOrgsTable) => {
  const defaultColDef = useMemo<ColDef>(() => {
    return {
      flex: 1,
    };
  }, []);

  const columnDefs: ColDef<OrgIdNameDto & { "": "" }>[] = useMemo(
    () => [
      {
        headerName: "Name",
        field: "name",
        cellStyle: { justifyContent: "start" },
      },
      {
        headerName: "",
        field: "",
        cellRenderer: GrantAccessColumn,
        cellStyle: { justifyContent: "end" },
      },
    ],
    []
  );

  return (
    <Grid
      item
      sx={{
        marginTop: "10px",
        width: "100%",
      }}
    >
      <IgTableWrapper minHeight={"100px"} height={null}>
        <AgGridReact<OrgIdNameDto>
          theme={myTheme}
          rowData={unassignedOrgs}
          domLayout={"autoHeight"}
          defaultColDef={defaultColDef}
          columnDefs={columnDefs}
          headerHeight={0}
          suppressCellFocus={true}
          suppressRowHoverHighlight={true}
          context={{ item, subscription, agency }}
        />
      </IgTableWrapper>
    </Grid>
  );
};
